<template>
	<div class="basic-container"  :class="{ 'basic-container--block': block }">
		<el-card class="basic-container__card" :body-style="styleName">
			<slot></slot>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: 'basicContainer',
		props: {
			radius: {
				type: [String, Number],
				default: 10,
			},
			background: {
				type: String,
			},
			block: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			styleName() {
				return {
					borderRadius: `${this.radius}px`,
					background: this.background,
				};
			},
		},
	};
</script>

<style lang="scss">
	.basic-container {

		box-sizing: border-box;
		background-color: white;
		//height: 88vh;
		height: 95vh;
		overflow-y: scroll;
		scrollbar-width: none;
		-ms-overflow-style: none;

		&--block {
			height: 100%;
			.basic-container__card {
				height: 100%;
			}
		}

		&__card {
			width: 100%;
		}

		&:first-child {
			padding-top: 0;
		}
	}

	.basic-container::-webkit-scrollbar { width: 0 !important }
	.basic-container { -ms-overflow-style: none; }
	.basic-container { overflow: -moz-scrollbars-none; }
</style>
